import { useEffect } from 'react';
import { LoadingScreen } from '@/components/loading-screen';
import { useProgress } from '@/hooks/useProgress';
import { useLoadingStore } from '@/stores/feedback';

export const LoadingRenderer = () => {
  const isLoading = useLoadingStore((state) => state.actived);
  const isPseudoLoading = useLoadingStore((state) => state.pseudo);
  const duration = useLoadingStore((state) => state.duration);
  const variant = useLoadingStore((state) => state.variant);
  const content = useLoadingStore((state) => state.content);
  const progress = useLoadingStore((state) => state.progress);
  const hideProgressBar = useLoadingStore((state) => state.hideProgressBar);
  const { isActive, progress: pseudoProgress, startProgress, finishProgress } = useProgress();

  useEffect(() => {
    if (isPseudoLoading) {
      startProgress({ duration, pseudo: true });
    } else {
      finishProgress();
    }
  }, [isPseudoLoading, duration, startProgress, finishProgress]);

  if (!isLoading && !isActive) {
    return null;
  }
  return (
    <LoadingScreen
      variant={variant ?? 'overlay'}
      content={content}
      progress={isActive ? pseudoProgress : progress}
      hideProgressBar={hideProgressBar}
    />
  );
};
